import { render, staticRenderFns } from "./SubgroupNameList.vue?vue&type=template&id=7c641838&"
import script from "./SubgroupNameList.vue?vue&type=script&lang=js&"
export * from "./SubgroupNameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports